import axiosInstance, { cancelTokenSource } from "./axios-instance";

const baseUrl = process.env.REACT_APP_API_URL;
export default class HttpService {
  static async get(
    _url,
    queryParams,
    handleDiscard = () => {}, //NOSONAR
    responseType = "json"
  ) {
    const url = `${baseUrl}${_url}`;
    try {
      handleDiscard(cancelTokenSource);
      let config = {
        cancelToken: cancelTokenSource.token,
        responseType,
      };
      if (queryParams) {
        config = {
          ...config,
          params: queryParams,
        };
      }

      return await axiosInstance.get(url, config);
    } catch (error) { // NOSONAR
      throw error;
    }
  }

  static async post(_url, data, headers, handleDiscard = () => {}) { // NOSONAR
    const url = `${baseUrl}${_url}`;
    try {
      handleDiscard(cancelTokenSource);
      let config = {
        cancelToken: cancelTokenSource.token,
      };
      if (headers) {
        config = {
          ...config,
          headers,
        };
      }

      return await axiosInstance.post(url, data, config);
    } catch (error) { // NOSONAR
      throw error;
    }
  }

  static async put(_url, data, headers) {
    const url = `${baseUrl}${_url}`;
    try {
      let config = {
        cancelToken: cancelTokenSource.token,
        headers,
      };
      return await axiosInstance.put(url, data, config);
    } catch (error) { // NOSONAR
      throw error;
    }
  }

  static async delete(_url) {
    const url = `${baseUrl}${_url}`;
    try {
      return await axiosInstance.delete(url);
    } catch (error) { // NOSONAR
      throw error;
    }
  }
}
